import { render, staticRenderFns } from "./MattressSizeSelection.vue?vue&type=template&id=5730e762&scoped=true"
import script from "./MattressSizeSelection.vue?vue&type=script&lang=js"
export * from "./MattressSizeSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730e762",
  null
  
)

export default component.exports